import { render, staticRenderFns } from "./addTag.vue?vue&type=template&id=0006fb74&scoped=true"
import script from "./addTag.vue?vue&type=script&lang=js"
export * from "./addTag.vue?vue&type=script&lang=js"
import style0 from "./addTag.vue?vue&type=style&index=0&id=0006fb74&prod&lang=scss&scoped=true"
import style1 from "./addTag.vue?vue&type=style&index=1&id=0006fb74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0006fb74",
  null
  
)

export default component.exports